// @flow

import type {
  Product as ProductType,
  Article as ArticleType,
} from '../types/model';
import type { State } from './rootReducer';

import { selectors as categorySelectors } from './modules/categories';
import { selectors as productSelectors } from './modules/products';
import { selectors as articleSelectors } from './modules/articles';

export function getProductsByCategoryId(state: State, categoryId: number): Array<ProductType> {
  const category = categorySelectors.getById(state.categories, categoryId);

  return (
    category && category.products
      ? category.products.map(id => productSelectors.getById(state.products, id))
      : []
  );
}

export function getArticlesByCategoryId(state: State, categoryId: number): Array<ArticleType> {
  const category = categorySelectors.getById(state.categories, categoryId);

  return (
    category && category.products
      ? category.articles.map(id => articleSelectors.getById(state.articles, id))
      : []
  );
}



// WEBPACK FOOTER //
// ./src/redux/selectors.js